import * as React from "react";
import { cn } from "@/lib/utils";

export function Table({ className, ...props }: React.HTMLAttributes<HTMLTableElement>) {
	return <table className={cn("w-full caption-bottom text-sm text-gray-900", className)} {...props} />;
}

export function TableHeader({ className, ...props }: React.HTMLAttributes<HTMLTableSectionElement>) {
	return <thead className={cn("[&_tr]:border-b bg-gray-50/80", className)} {...props} />;
}

export function TableBody({ className, ...props }: React.HTMLAttributes<HTMLTableSectionElement>) {
	return <tbody className={cn("[&_tr:last-child]:border-0", className)} {...props} />;
}

export function TableFooter({ className, ...props }: React.HTMLAttributes<HTMLTableSectionElement>) {
	return (
		<tfoot className={cn("bg-gray-50 text-gray-900 [&>tr]:last:border-b-0", className)} {...props} />
	);
}

export function TableRow({ className, ...props }: React.HTMLAttributes<HTMLTableRowElement>) {
	return <tr className={cn("border-b transition-colors hover:bg-gray-50/60", className)} {...props} />;
}

export function TableHead({ className, ...props }: React.ThHTMLAttributes<HTMLTableCellElement>) {
	return <th className={cn("h-11 px-4 text-left align-middle text-xs font-medium text-gray-500", className)} {...props} />;
}

export function TableCell({ className, ...props }: React.TdHTMLAttributes<HTMLTableCellElement>) {
	return <td className={cn("p-4 align-middle text-sm text-gray-900", className)} {...props} />;
}

export function TableCaption({ className, ...props }: React.HTMLAttributes<HTMLTableCaptionElement>) {
	return <caption className={cn("mt-4 text-sm text-gray-500", className)} {...props} />;
}
